import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetaaldatumWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M32 10H8v22h24z"
    />
    <path
      fill="#D9F4D8"
      d="M32 13.89H8V32h24z"
    />
    <path
      fill="#00215B"
      d="M12.5 8h-1v4h1zM16.5 8h-1v4h1zM20.5 8h-1v4h1zM24.5 8h-1v4h1zM28.5 8h-1v4h1z"
    />
    <path
      fill="#60D15D"
      d="M28 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M28 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M28 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 19.43a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 19.43a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetaaldatumWijzigen);

export default ForwardRef;
